import { DeleteDriver } from "./DeleteDriver";
import { DriverLeaveQueueModal } from "./DriverLeaveQueueModal";
import { EditDriver } from "./EditDriver";

export const DriverModal = {
  Delete: DeleteDriver,
  Edit: EditDriver,
  LeaveQueue: DriverLeaveQueueModal
};
